import { useTasks } from './use-tasks';

// Single entry point to the shared completed task subscription. Lazily mounted:
// the listener only exists while a completed-consuming feeder is mounted. Every
// completed-deriving feeder subscribes through this one call so TanStack dedupes
// them onto one Firestore listener — never inline `{ completedOnly: true }` elsewhere.
export const useAllCompletedTasks = (enabled = true) =>
  useTasks({ completedOnly: true }, enabled);
